import { AuthFetchWithResponse } from 'src/Types/api'
import { ApiResult } from '../../api'
import { StatusCodes } from '../../http-status-codes'
import { InstallationsDto } from './dto'
import installationsDtoToModelTransformer from './transformer/installations-from-dto-to-model.transfromer'
import { Installation } from '../models/installation.model'
import { handleFetchError } from 'src/Libs/api/utils'
import { addMonths, format } from '@e3dc-react/shell/Libs/date'
import { INSTALLATION_STATEMENT_DEADLINE_THRESHOLD_MONTHS } from '../constants'

/**
 * fetch installations whose installation statement submission deadline is near or over.
 * (based on a predefined threshold in months)
 */
export const getInstallationsWithApproachingInstallationStatementDeadline = async (
  authFetch: AuthFetchWithResponse
): Promise<ApiResult<Installation[]>> => {
  try {
    const now = new Date()
    /* calculate the threshold date based on the current date and the predefined threshold in months */
    const thresholdDate = format(addMonths(now, INSTALLATION_STATEMENT_DEADLINE_THRESHOLD_MONTHS), 'yyyy-MM-dd HH:mm:ss')

    const response = await authFetch<InstallationsDto>({
      path: `installations?deviceLinkFilter=ibnDeadlineAt<${thresholdDate}`,
      method: 'GET',
      endpoint: process.env.REACT_APP_INSTALLATIONS_ENDPOINT,
    })
    if (response.status === StatusCodes.OK) {
      const data = installationsDtoToModelTransformer(response.data)
      return new ApiResult<Installation[]>(data)
    }
    return new ApiResult<Installation[]>(null, true)
  } catch (error) {
    return handleFetchError<Installation[]>(error)
  }
}
